import {genToken} from "../helpers/utils";

export default {
    methods: {
        /**
         * Gerencia as requisições efetuadas com o axios,
         * caso haja requisições pendentes, cancela estas requisições
         */
        newReq(page = 1) {
            const axios_req = this.$store.getters['requisitions'];

            /**
             * Só cancela as requisições quando é a primeira página, pois as outras é paginação
             */
            if (axios_req && page === 1) {
                Object.entries(axios_req).forEach(([token])=> {
                    const source = axios_req[token];
                    source.cancel && source.cancel(token);
                    /**
                     * Após o cancelamento remove da store;
                     */
                    this.$store.dispatch('remReq', token);
                })
            }

            /**
             * Token gerado pelo axios
             */
            const source = this.$axios.CancelToken.source();

            /**
             * Token que é enviado ao servidor, para cancelar a transação do Banco pelo PID
             */
            const token = genToken();

            /**
             * Armazena na Store todas as requisições, para ser recuperada e cancelada de qualquer página
             */
            this.$store.dispatch('addReq', ({token, source}));

            /**
             * Retorna os tokens que serão atrelados as requisições
             */
            return {
                source,
                token
            };
        },
    }
};
